import React, { useState, useEffect } from 'react';
import axios from 'axios';

import { useParams, useNavigate } from 'react-router-dom';

// core components
import Navbar from "../layouts/Navbar.js";
import Footer from "../layouts/Footer.js";

import '../../assets/css/Board.css'

export default function ContactView() {

  const navigate = useNavigate();

  const { param } = useParams();

  const [isLoading, setIsLoading] = useState(true);

  const [formData, setFormData] = useState({
    name: '',
    title: '',
    message: '',
    published: 0,
  });

  useEffect(() => {
    // 서버에서 게시글 데이터 가져오는 로직
    async function selectContactById() {

      //console.log("select param id : " + param);

      try {
        //로딩중 표기
        setIsLoading(true);

        const response = await axios.get(`/contact/selectContactById?id=${param}`,
        { baseURL : process.env.REACT_APP_SERVER_URL },
        {
          withCredentials: true
        });

        const data = response.data;

        //console.log(data);

        //console.log("Posts Return : " + JSON.stringify(data.result));

        // 데이터를 성공적으로 가져왔으므로 로딩 상태를 false로 변경
        setIsLoading(false);

        setFormData({
          id : data.result.id,
          name : data.result.name,
          email : data.result.email,
          phone : data.result.phone,
          title : data.result.subject,
          message : data.result.message,
          date : data.result.created_at.substring(0,10)
        })

      } catch (error) {
        console.error('게시글 조회 오류:', error);
      }
    }

    selectContactById();
  }, []);

  const goBack = (e) => {
    e.preventDefault();
    
    navigate("/ContactList");
  }

  const goDelete = async (e) => {
    e.preventDefault();

    //console.log("delete param id : " + param);

    try {
      await axios.get(`/contact/deleteContactById?id=${param}`,
      { baseURL : process.env.REACT_APP_SERVER_URL },
      {
        withCredentials: true
      })
      .then((response) => {
        //console.log(response);

        const data = response.data;
        //console.log(data);
        const messages = data.messages;

        // 성공 메세지 표출
        if (messages && messages.success) {
          alert(messages.success);
          // 성공 후 페이지 이동
          return navigate("/ContactList");
        }
      })

    } catch (error) {
      console.error('게시글 삭제 오류:', error);
    }
  }

  return (
    <>
    <Navbar/>
      <div className="wrapper">
        <div className="page-header">
          <div className="page-header-image" />

            <div id="ContactList" className="register-page">
            <div className="Section">
                <div className="cardWithTitle">
                <div className="SectionHeaderFull">
                    <div className="SectionHeaderTxtbox">
                    <div className="SectionHeaderCategory CategoryDark">Contact List</div>
                    <div className="SectionHeaderTitle">문의리스트</div>
                    <div className="SectionHeaderDescription">
                      서비스 문의를 통해 사용자가 문의한 내역을 확인합니다
                    </div>
                    </div>
                </div>

                <div className="SectionContents" style={{marginTop:'30px'}}>
                    {isLoading &&
                          // 로딩 중일 때 로딩 스피너 또는 메시지 표시
                        <div className="loader">
                          <div className="loader-container">
                            <p className='loader-title'>Loading...</p>
                          </div>
                        </div>
                    }
                    <div className="form-control">
                    <form>
                        <div className="form-box">
                            <div className="form-label">문의자</div>
                            <input
                            className="form-result"
                            id="name" 
                            name="name"
                            value={formData.name}
                            disabled/>
                        </div>
                        <div className="form-box">
                            <div className="form-label">문의이메일</div>
                            <input
                            className="form-result"
                            id="email" 
                            name="email"
                            value={formData.email}
                            disabled/>
                        </div>
                        <div className="form-box">
                            <div className="form-label">연락처</div>
                            <input
                            className="form-result"
                            id="phone" 
                            name="phone"
                            value={formData.phone}
                            disabled/>
                        </div>
                        <div className="form-box">
                        <label htmlFor="title">
                            <div className="form-label">제목</div>
                            <input
                            type="text"
                            className="form-result"
                            id="title" 
                            name="title"
                            value={formData.title}
                            disabled/>
                        </label>
                        </div>
                        <div className="form-box">
                        <label htmlFor="content">
                            <div className="form-label">내용</div>
                            <textarea 
                            className="form-result-area"
                            id="content"
                            name="content" 
                            value={formData.message}
                            disabled />
                        </label>
                        </div>
                        <div className="form-box">
                        <label htmlFor="date">
                            <div className="form-label">전송일</div>
                            <input
                            type="text"
                            className="form-result"
                            id="date" 
                            name="date"
                            value={formData.date}
                            disabled/>
                        </label>
                        </div>

                        <div className="board-view-button-area">
                          <button className="form-button-sm itsBtnGray" onClick={goBack}>이전</button>
                          <div className="board-view-modify-area">
                            <button className="form-button-sm" style={{visibility:'hidden'}}>수정</button>
                            <button className="form-button-sm" onClick={goDelete}>삭제</button>
                          </div>
                        </div>
                    </form>
                    </div>
                </div>
                </div>

            </div>
            </div>
          
        </div>
      </div>
    <Footer />
    </>
  );
}